export default "__VITE_ASSET__BG04SC_C__"